import { Typography, Box, type BoxProps } from "@mui/material";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { ExternalLink } from "src/components/ExternalLink";
import { EmeriaUrl } from "src/constants";
import { useBrand } from "src/hooks/useBrand";

import { LegalIdentity } from "./legal-identity";

export const LegalInfo = (props: BoxProps) => {
  const { t } = useTranslation();
  const { identity, dataProtectionPolicy } = useBrand();

  return (
    <Box {...props}>
      <Typography>
        <Trans
          i18nKey="Les données à caractère personnel recueillies par la société {{brandName}}, filiale d'<emeriaLink>Emeria Europe</emeriaLink>, responsable du traitement, font l'objet d'un traitement automatisé pour les besoins de la gestion de la relation client et la bonne exécution du contrat. Ces données sont destinées à <emeriaLink>Emeria Europe</emeriaLink> et à ses filiales et seront conservées pour une durée maximale de 5 ans après la fin de la relation contractuelle, conformément à l'article 2224 du code civil et à l'article L561-12 du code monétaire et financier."
          values={{ brandName: identity.name }}
          components={{
            emeriaLink: (
              <ExternalLink href={EmeriaUrl}>{t("Emeria Europe")}</ExternalLink>
            ),
          }}
        />
      </Typography>
      <Typography>
        <Trans
          i18nKey="Conformément à la loi n°78-17 du 6 janvier 1978 et au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits d'accès, d'opposition, de rectification, de portabilité, de limitation et de suppression de vos données personnelles. Pour exercer ces droits, veuillez contacter le Délégué à la Protection des Données (DPO) du Groupe Emeria via <formLink>le formulaire accessible ici</formLink>. Pour plus d'information, consultez <policyLink>notre politique sur la protection des données personnelles</policyLink>."
          components={{
            formLink: (
              <ExternalLink href={dataProtectionPolicy.formUrl}>
                {t("le formulaire accessible ici")}
              </ExternalLink>
            ),
            policyLink: (
              <ExternalLink href={dataProtectionPolicy.url}>
                {t(
                  "notre politique sur la protection des données personnelles",
                )}
              </ExternalLink>
            ),
          }}
        />
      </Typography>
      <Typography>
        <LegalIdentity />
      </Typography>
    </Box>
  );
};
